<template>
  <div class="wrapper du-wrapper">
    <side-bar backgroundColor="azure" backgroundImage="../img/sidebar-5.jpg" :title="title||'Document unique'" class="du-nav" link="" >
      <sidebar-link to="identity" class="du-nav-item">
        <i class="nc-icon nc-badge"></i>
        <p>Identité</p>
      </sidebar-link>
      
      <sidebar-link to="photos" class="du-nav-item">
        <i class="nc-icon nc-album-2"></i>
        <p>Photos</p>
      </sidebar-link>

      <sidebar-link to="workingunits" class="du-nav-item">
        <i class="nc-icon nc-settings-90"></i>
        <p>Unités Travail</p>
      </sidebar-link>

      
      <sidebar-link to="stats" class="du-nav-item">
        <i class="nc-icon nc-chart-pie-36"></i>
        <p>Statistiques</p>
      </sidebar-link> 
     

      <sidebar-link v-for="family of catalog.RiskFamilies" :key="family.Major"  :to="'family/'+family.Major" class="du-nav-item">
        <i class="nc-icon nc-bullet-list-67"></i>
        <p class="col-10 text-truncate" >{{ family.ToString() }}</p>
        <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
          5
        </span>
      </sidebar-link>

      
      
    </side-bar>
    <div class="main-panel">
      
      
      <dashboard-content @click="toggleSidebar">

      </dashboard-content>

    </div>
  </div>
</template>
<style lang="css">
  .du-nav {
    width: 350px;
  }
  /*.du-nav .du-nav-item {
    width: 350px;
  }*/
  .du-wrapper > .du-nav {
    width: 350px;
  }

  .du-nav > .sidebar-wrapper{
    width: 350px;
  }

 .du-wrapper > .main-panel {
  width: calc(100% - 350px);
 }
</style>
<script>
  import TopNavbar from './PPETopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'

  import Business from 'ppe-business'

  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
    },
    mounted() {
      // this.$http.get('/eu/operation_home?id=0') // this.$router.app._route.query.id)
      //   .then(response => {
      //     console.log("/eu/operation_home:DATA", response.data)
      //   } )
      //   .catch(err => {
      //     // Clone the error to read the status property (otherwise it can only be read once !!!!)
      //     let error = JSON.parse( JSON.stringify(err) )
      //     console.error("ERROR", JSON.stringify(error))
			// 		swal("Erreur", JSON.stringify(err.response ? err.response.data : error.message), "error");
      //   })
      this.$eventbus.$on('on-title', (title) =>{
        console.log("refreshTitle", title)
        this.title = title
      })

    },
    data() {
      return {
        catalog : Business.DUCatalog,
        title: "",
      }
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      },
    }
  }

</script>
